import React, { Component } from 'react';
import _ from 'lodash';
import qs from "qs";
import {withRouter} from "react-router-dom";
import {Card, CardBody, CardHeader, Collapse} from "reactstrap";
import ReactSlider from 'react-slider'

import CollapseButton from '../dumb/collapseButton';
import styled from 'styled-components';

const StyledSlider = styled(ReactSlider)`
    width: 100%;
    height: 25px;
`;

const StyledThumb = styled.div`
    height: 25px;
    line-height: 25px;
    width: 35px;
    text-align: center;
    background-color: #000;
    color: #fff;
    border-radius: 50%;
    cursor: grab;
`;

const Thumb = (props, state) => <StyledThumb {...props}>{state.valueNow}</StyledThumb>;

const StyledTrack = styled.div`
    top: 0;
    bottom: 0;
    background: ${props => (props.index === 2 ? '#f00' : props.index === 1 ? '#0f0' : '#ddd')};
    border-radius: 999px;
`;

const Track = (props, state) => <StyledTrack {...props} index={state.index} />;

class AgeFilter extends Component {

    constructor(props){
        super(props);
        this.renderAgeSlider = this.renderAgeSlider.bind(this);
        this.handleAgeChange = this.handleAgeChange.bind(this);
        this.toggleCollapse = this.toggleCollapse.bind(this);
        this.updateAPIURL = this.updateAPIURL.bind(this);

        this.state = {
            value: '',
            minAge: [],
            maxAge: [],
            isOpen: false,
            activeCount: 0
        }
    }

    static getDerivedStateFromProps(newprops){
        let new_qs = qs.parse(newprops.location.search, { ignoreQueryPrefix: true });
        let minAge = ('min_age' in new_qs)? _.split(new_qs.min_age, '_'):[];
        let maxAge = ('max_age' in new_qs)? _.split(new_qs.max_age, '_'):[];
        return {
            minAge: minAge,
            maxAge: maxAge,
            // activeCount was previously never set (always undefined), so the
            // "N active" badge could never appear even with a range applied.
            activeCount: (minAge.length > 0 || maxAge.length > 0) ? 1 : 0
        }

    }

    toggleCollapse(){
        this.setState({isOpen: !this.state.isOpen})
    }

    updateAPIURL(api_qs, newlistprops){

        let new_qs = qs.parse(newlistprops.location.search, { ignoreQueryPrefix: true });
        let minAgeFilter = ('min_age' in new_qs)? _.split(new_qs.min_age, '_'):[];
        let maxAgeFilter = ('max_age' in new_qs)? _.split(new_qs.max_age, '_'):[];

        // Require both bounds before building the filter - previously only
        // checked minAgeFilter.length, so a URL with min_age but no max_age
        // would send val: undefined for the upper bound.
        if(minAgeFilter.length > 0 && maxAgeFilter.length > 0){

                let filter_qs = {"name":"sample","op":"has","val":{"and":[
                        {"name":"age_at_sampling","op":"ge","val":minAgeFilter[0]},
                        {"name":"age_at_sampling","op":"le","val":maxAgeFilter[0]}]}}


                if('filter' in api_qs){
                    api_qs.filter.push(filter_qs)
                } else {
                    api_qs['filter'] = [filter_qs]
                }

        }

        return api_qs

    }


    handleAgeChange(event){

        let min_age = event[0];
        let max_age = event[1];

        if(min_age >= 0 && max_age <= 100){

            let current_qs = qs.parse(window.location.search, { ignoreQueryPrefix: true });

            current_qs.min_age = min_age;
            current_qs.max_age = max_age;
            current_qs.page = undefined;
            this.props.history.push(window.location.pathname + qs.stringify(current_qs, { addQueryPrefix: true }));
        }
    }

    renderAgeSlider(){
        // Slider now reflects the current min_age/max_age from the URL instead
        // of always resetting to [0, 100] via defaultValue (which only applies
        // on first mount and ignores state changes thereafter).
        let minAge = this.state.minAge.length > 0 ? Number(this.state.minAge[0]) : 0;
        let maxAge = this.state.maxAge.length > 0 ? Number(this.state.maxAge[0]) : 100;

        return(

            <StyledSlider value={[minAge, maxAge]} renderTrack={Track} renderThumb={Thumb} onAfterChange={this.handleAgeChange}/>

        )
    }

    componentDidMount() {
        // Was registered in the constructor with no matching unmount cleanup -
        // moved here and paired with componentWillUnmount below, matching the
        // lifecycle pattern used by every other filter in this codebase.
        this.props.registerRequest(this.updateAPIURL);
    }

    componentWillUnmount() {
        this.props.unregisterRequest(this.updateAPIURL);
    }

    render(){
        return(
            <Card className="genetic-filters mb-2 z0 hover">
                <CardHeader className="justify-content-between d-flex" onClick={this.toggleCollapse} >
                    <div className="d-inline w-50" >Age</div>
                    <div className="d-inline-block">
                        {this.state.activeCount > 0 && (<strong>{this.state.activeCount + ' active'}</strong>)}
                    </div>
                    <CollapseButton isOpen={this.state.isOpen} onClick={this.toggleCollapse} />
                </CardHeader>
                <Collapse isOpen={this.state.isOpen}>
                    <CardBody>
                        { this.renderAgeSlider() }
                    </CardBody>
                </Collapse>
            </Card>
        )
    }
}

export default withRouter(AgeFilter)